import React from "react";
import BRAND_11 from "../../../assets/v4-reports-assets/icons/brands/brand-11.png";
import BRAND_12 from "../../../assets/v4-reports-assets/icons/brands/brand-12.png";
import BRAND_13 from "../../../assets/v4-reports-assets/icons/brands/brand-13.png";
import BRAND_14 from "../../../assets/v4-reports-assets/icons/brands/brand-14.png";
import BRAND_15 from "../../../assets/v4-reports-assets/icons/brands/brand-15.png";
import BRAND_16 from "../../../assets/v4-reports-assets/icons/brands/brand-16.png";
import INSTALL_SECTION from "../../../assets/v4-reports-assets/images/section-two/install-section-image.png";
import "./styles.scss";

const Section6 = () => {
  return (
    <>
      <section class="step____3"></section>
    </>
  );
};

const Section6EX = () => {
  return (
    <>
      <section class="body-section-two">
        <div class="grid-col-one">
          <div style={{ padding: "5%" }}>
            <img src={INSTALL_SECTION} class="column-image" />
          </div>
        </div>
        <div class="grid-col-two">
          <div style={{ padding: "10%" }} class="column-container">
            <div class="column-header">
              <h1 class="column-header__number">03.</h1>
              <h4 class="column-header__title">
                Qualify for Insurance Coverage
              </h4>
              <p class="column-header__caption">
                Our team ensures all backend processing is handled with
                precision
              </p>
            </div>

            <div class="column-brand-images">
              <img src={BRAND_11} alt="" class="brand-image" />
              <img src={BRAND_12} alt="" class="brand-image" />
              <img src={BRAND_13} alt="" class="brand-image" />
              <img src={BRAND_14} alt="" class="brand-image" />
              <img src={BRAND_15} alt="" class="brand-image" />
              <img src={BRAND_16} alt="" class="brand-image" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Section6;
